"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelYellowToast = cancelYellowToast;
exports.getAllRecordsInList = getAllRecordsInList;
exports.getLabsOnHomeSummary = getLabsOnHomeSummary;
exports.getMyPrescriptionDetails = getMyPrescriptionDetails;
exports.getMyRecords = getMyRecords;
exports.getSyncStatus = getSyncStatus;
exports.guestFlowLabReports = guestFlowLabReports;
exports.markRecordViewed = markRecordViewed;
exports.markReportViewed = markReportViewed;
exports.orderPrescriptionRX = orderPrescriptionRX;
exports.orderPrescriptionTicketNotification = orderPrescriptionTicketNotification;
exports.postMyPrescriptionDetails = postMyPrescriptionDetails;
exports.recordRevampCount = recordRevampCount;
exports.syncData = syncData;
exports.uploadRecordWaitingRoom = uploadRecordWaitingRoom;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getMyRecords(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_MY_RECORDS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getMyPrescriptionDetails(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_MY_PRESCRIPTIONDETAILS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function orderPrescriptionTicketNotification(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.INSTORE_ORDER_BASE_URL}/v1/submit`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  options.body = requestParams;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function postMyPrescriptionDetails(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.POST_MY_PRESCRIPTION_ORDERDETAILS;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function orderPrescriptionRX(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.ORDER_PRESCRIPTION;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function uploadRecordWaitingRoom(params, tokenData) {
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_DOCUMENTS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.GET
  // });
}
function getSyncStatus(requestParams, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.SYNC_DATA_ENDPOINT + (requestParams === null || requestParams === void 0 ? void 0 : requestParams.patientID) + _ApiConst.SYNC_STATUS_CONST;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function syncData(requestParams, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.SYNC_DATA_ENDPOINT + (requestParams === null || requestParams === void 0 ? void 0 : requestParams.patientID) + _ApiConst.SYNC_DATA_CONST;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getLabsOnHomeSummary(reqParams, tokenData) {
  const {
    patientId
  } = reqParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${patientId}/${_ApiConst.LAB_REPORT_HOME}/summary`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function markReportViewed(reqParams, tokenData) {
  const {
    patientId,
    userRecordId
  } = reqParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}/${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${patientId}/${_ApiConst.LAB_REPORT_HOME}/${userRecordId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = null;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function guestFlowLabReports(requestParams, tokenData) {
  const queryString = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GUEST_FLOW_LAB_RESULTS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  options.body = requestParams;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getAllRecordsInList(requestParams, tokenData) {
  const {
    patientId,
    recordType,
    reqParams
  } = requestParams;
  const queryString = (0, _utils.getQuery)(reqParams);
  const apiEndPoint = `${_ApiConst.BASE_URL}/${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/records/${patientId}/${recordType}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function markRecordViewed(requestParams, tokenData) {
  const {
    patientId,
    userRecordId
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}/${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${patientId}/records/${userRecordId}/report/viewed`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function cancelYellowToast(requestParams, tokenData) {
  const {
    patientId
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}/${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${patientId}/newRecordStatus`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = null;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function recordRevampCount(requestParams, tokenData) {
  const {
    patientId
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/records/${patientId}/count`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}